import React from "react";
import { useNavigate } from "react-router-dom";
import WriteBox from "../../QuestionPage/WordBox";
import QuestionBox from "../../QuestionPage/questionbox";
import { useState, useEffect } from "react";
import MCQQuestion from "../../QuestionPage/Mcq";
import FillInTheBlanksDraggable from "../../QuestionPage/FillInTheBlanksDraggable";

// Fetching Data from the API]

// End

// Page Html
export default function ReadingFillInTheBlanksMockPage({ question ,onInputChange,questionNumber,maxQuestion}) {
  // End
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };

  const [originalWords, setOriginalWords] = useState("");
  const [Options, setOptions] = useState([]);
  const [replacedOptions, setReplacedOptions] = useState([]);
  const [submittedOptions, setSubmittedOptions] = useState([]);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    // Reset replacedOptions whenever question changes
    setReplacedOptions([]);
  }, [question]);

  useEffect(() => {
    // Set the state when the question prop changes
    setOriginalWords(question.question);
    setOptions(question.option.map(option => option.options)); // Extracting options array

  }, [question]);
    // Ensure onInputChange is called whenever submittedOptions changes
    useEffect(() => {
      if (submittedOptions !== "") {
        onInputChange(submittedOptions);
        console.log("submittedOptions", submittedOptions);
      }
    }, [submittedOptions]);

  return (
    <div>
      <div className="min-h-[calc(100vh-230px)] overflow-hidden rounded-md border border-slate-200 bg-white p-4 shadow-sm sm:p-6 lg:p-8">
        <div className="h-1.5 rounded-full bg-violet-600"></div>
        <h3 className="pt-4 text-2xl font-extrabold text-gray-900 sm:text-3xl">
          Reading Fill in the Blanks
        </h3>
        <h2 className="hidden">
          {" "}
        </h2>
        <h2 className="mt-3 inline-flex rounded-md bg-violet-50 px-3 py-2 text-sm font-bold text-violet-800 ring-1 ring-violet-100">
          {" "}
        Question {questionNumber} of {maxQuestion}
        </h2>
        <p className="mt-4 max-w-5xl text-sm leading-6 text-gray-600 sm:text-base">
          Read the text and fill each blank with the correct option.
        </p>
        <FillInTheBlanksDraggable
            sentence={originalWords}
            options={Options}
            submitted={submitted}
            onOptionsChange={setSubmittedOptions}
          />

      </div>
    </div>
  );
}


